import React from "react";
import "./button.css";

/*
    Button control with css style
    props:
        - primary: bool
        - secondary: bool
        - tertiary: bool
            only one of primary, secondary or teriary should be set.  By default button is primary
        - inverted: bool
            inverts the color scheme
        - onClick: (e) => void
            onClick: calback passing the click event
*/

const Button = (props) => {
    const { primary, secondary, tertiary, inverted, className, children, onClick, ...otherProps } = props;
    var cName = className ? className + " bell-btn" : "bell-btn";

    if (secondary || tertiary) {
        cName += " secondary";
    } else {
        cName += " primary";
    }

    if (secondary) {
        cName += " bordered";
    }

    if (inverted) {
        cName += " inverted";
    }

    return (
        <button
            className={cName}
            onClick={(e) => {
                props.onClick(e);
                e.stopPropagation();
            }}
            {...otherProps}>
            {children}
        </button>
    );
};

export default Button;
